"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const YouTube = createSVGIcon(
  <>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.715 3.429H4.286A3.43 3.43 0 0 0 .857 6.857v10.286a3.43 3.43 0 0 0 3.429 3.428h15.429a3.43 3.43 0 0 0 3.428-3.428V6.857a3.43 3.43 0 0 0-3.428-3.428Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.103 15.977v-7.2a.669.669 0 0 1 1.028-.583l6.172 3.6a.686.686 0 0 1 0 1.183l-6.172 3.6a.687.687 0 0 1-1.028-.6Z"
    />
  </>,
  "YouTube",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "YouTube",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  }) // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
